export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['ユーザー管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ユーザー管理',
        to: '/users',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['業種']
      },
      {
        _name: 'CSidebarNavItem',
        name: '介護業',
        to: '/industry/1',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ビルクリーニング業',
        to: '/industry/2',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '素形材産業',
        to: '/industry/3',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '産業機械製造業',
        to: '/industry/4',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '電気・電子情報関連産業',
        to: '/industry/5',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '建設業',
        to: '/industry/6',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '造船・舶用業',
        to: '/industry/7',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '自動車整備業',
        to: '/industry/8',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '航空業',
        to: '/industry/9',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '宿泊業',
        to: '/industry/10',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '農業',
        to: '/industry/11',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '漁業',
        to: '/industry/12',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '飲食料品製造',
        to: '/industry/13',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: '外食業',
        to: '/industry/14',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['その他']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'パスワード変更',
        to: '/change_password',
        icon: 'cil-chart-pie'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ログアウト',
        to: '/logout',
        icon: 'cil-chart-pie'
      },
    ]
  }
]
